module.exports = __webpack_public_path__ + "static/img/10.818f9bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/10.png
// module id = ypxd
// module chunks = 0